import useApi from 'hooks/useApi'
import { useQuery } from '@tanstack/react-query'

const useGetContent = ({ uuid, contentType }) => {

  const { apiFetch } = useApi();

  const url = `/${contentType}s/${uuid}`

  const getContent = () => {
    if (!uuid) return null
    
    return apiFetch({ url })
      .then(res => res.data)
  }

  const options = {
    staleTime: 60000 * 30, // 30 min
    placeholderData: null,
  }

  return useQuery([contentType, uuid], getContent, options)
}

export default useGetContent
